import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import styled, { ThemeConsumer } from 'styled-components';
import AhLogo from './AhLogo';
import { selectEntity } from '../redux/slices/hassioSlice';
import { findTimeZone, getZonedTime, format } from 'timezone-support';
import { toDate, format as formatTz, utcToZonedTime } from 'date-fns-tz';
import { nl as localeNL } from 'date-fns/locale';
import { isNightMode as selectIsNightMode } from '../utils/hassio';
import { NIGHT_MODE_RED } from '../theme/colors';
import nl_flag from '../assets/images/flags/nl.svg';
import background1 from '../assets/images/work-backgrounds/klaasvaak.png';
import background2 from '../assets/images/work-backgrounds/wonderhotel.png';
import background3 from '../assets/images/work-backgrounds/pode.png';
import foreground from '../assets/images/work-backgrounds/pjotr-front.png';

const colors = {
  primary: '#F6F6F6',
  secundary: '#848484'
};

const FlexOuterWrapper = styled.div`
  font-family: ${props => false ? "'Danse Macabre', sans-serif" : "'Inter', sans-serif"};
  font-feature-settings: 'dlig' on;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.primary};
  justify-content: space-between;
  height: 100vh;
  text-transform: ${props => false ? 'uppercase' : 'none'};
  position: relative;
`;

const AlternateA = styled.span`
  font-variation-settings: 'ss01' on;
`;

const TopText = styled.div`
  font-size: 6vw;
  font-weight: 600;
  color: ${colors.secundary};
  margin-top: 5vw;
  text-shadow: 3px 3px 0 black, -3px -3px 0 black, 3px -3px 0 black, -3px 3px 0 black;
  opacity: ${({ isNightMode }) => (isNightMode ? 0 : 1)};
  transition: opacity 3s ease-in-out;
  pointer-events: ${({ isNightMode }) => (isNightMode ? 'none' : 'auto')};
`;

const StartTime = styled.span`
  color: ${colors.primary};
`;

const CountdownWrapper = styled.div`
  font-family: 'Inter', sans-serif;
  text-transform: none;
  text-shadow: 5px 5px 0 black, -5px -5px 0 black, 5px -5px 0 black, -5px 5px 0 black;
`;

const CountdownValue = styled.span`
  font-size: 30vw;
  font-weight: 600;
  color: ${props => props.isRed ? '#FF3B30' : (props.isNightMode ? NIGHT_MODE_RED : 'inherit')};
  transition: color 3s ease-in-out;
`;
const CountdownUnit = styled.span`
  font-size: 16vw;
  font-weight: 600;
  margin-left: 1.2vw;
  color: ${props => props.isRed ? '#FF3B30' : (props.isNightMode ? NIGHT_MODE_RED : 'inherit')};
  transition: color 3s ease-in-out;
  /* text-transform: uppercase; */
`;

const CountdownVertrek = styled.span`
  text-transform: uppercase;
  font-size: 16vw;
  font-weight: 600;
  color: ${props => props.isNightMode ? NIGHT_MODE_RED : 'inherit'};
  transition: color 3s ease-in-out;
`;

const BottomClock = styled.div`
  font-size: ${props => false ? '9vw' : '8vw'};
  font-weight: 600;
  margin-bottom: 5vw;
  text-shadow: 3px 3px 0 black, -3px -3px 0 black, 3px -3px 0 black, -3px 3px 0 black;
  transform: ${props => props.shouldScale ? 'scale(1.4)' : 'scale(1)'};
  transform-origin: center bottom;
  transition: transform 3s ease-in-out;
  opacity: ${({ isNightMode }) => (isNightMode ? 0 : 1)};
  transition: opacity 3s ease-in-out, transform 3s ease-in-out;
  pointer-events: ${({ isNightMode }) => (isNightMode ? 'none' : 'auto')};
`;

const SecundaryColor = styled.span`
  color: ${colors.secundary};
`;

const Flag = styled.img`
  border-radius: 0.9vw;
  height: 5.7vw;
  margin-right: 2vw;
  margin-top: 0.25vw;
  box-shadow: 3px 3px 0 black, -3px -3px 0 black, 3px -3px 0 black, -3px 3px 0 black;
`;

const BackgroundOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${props => (props.hoursLeft >= 2) ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${props.background})` : 'none'};
  background-size: cover;
  background-position: center;
  z-index: -1;
  opacity: ${props => props.hideBackground ? 0 : 1};
  transition: opacity 3s ease-in-out;
`;

const ForegroundOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${props => (props.hoursLeft >= 2) ? `url(${foreground})` : 'none'};
  background-size: cover;
  z-index: 999;
  pointer-events: none;
  opacity: ${props => props.hideBackground ? 0 : 1};
  transition: opacity 3s ease-in-out;
`;

const Countdown = props => {
  const { hoursLeft, minutesLeft, isRed, showVertrek, isNightMode } = props;
  // const hoursLeft = 0;
  // const minutesLeft = 34;

  if (showVertrek) {
    return <CountdownWrapper><CountdownVertrek isNightMode={isNightMode}>Vertrek</CountdownVertrek></CountdownWrapper>;
  }

  if (isRed) {
    // For red countdown, show total minutes (can be negative)
    const totalMinutes = hoursLeft * 60 + minutesLeft;
    return (<CountdownWrapper>
      <CountdownValue isRed={isRed} isNightMode={isNightMode}>{totalMinutes}</CountdownValue>
      <CountdownUnit isRed={isRed} isNightMode={isNightMode}>min</CountdownUnit>
    </CountdownWrapper>);
  }

  if (hoursLeft < 0 || minutesLeft < 0) {
    return <CountdownWrapper><CountdownVertrek isNightMode={isNightMode}>Vertrek</CountdownVertrek></CountdownWrapper>;
  }

  if (hoursLeft == 0) {
    return (<CountdownWrapper>
      <CountdownValue isNightMode={isNightMode}>{minutesLeft}</CountdownValue>
      <CountdownUnit isNightMode={isNightMode}>min</CountdownUnit>
    </CountdownWrapper>);
  }

  if (minutesLeft == 0) {
    return (<CountdownWrapper>
      <CountdownValue hoursLeft={hoursLeft} isNightMode={isNightMode}>{hoursLeft}</CountdownValue>
      <CountdownUnit hoursLeft={hoursLeft} isNightMode={isNightMode}>uur</CountdownUnit>
    </CountdownWrapper>);
  }

  return (<CountdownWrapper>
    <CountdownValue hoursLeft={hoursLeft} isNightMode={isNightMode}>{hoursLeft}</CountdownValue>
    <CountdownUnit hoursLeft={hoursLeft} isNightMode={isNightMode}>u </CountdownUnit>
    <CountdownValue hoursLeft={hoursLeft} isNightMode={isNightMode}>{minutesLeft.toString().padStart(2, '0')}</CountdownValue>
    <CountdownUnit hoursLeft={hoursLeft} isNightMode={isNightMode}>m</CountdownUnit>
  </CountdownWrapper>);
};

class WorkShift extends Component {
  constructor(props) {
    super(props);
    this.backgrounds = [background1, background2, background3];
    this.state = {
      background: this.backgrounds[Math.floor(Math.random() * this.backgrounds.length)]
    };
  }

  componentDidMount() {
    // Set initial timer
    this.switchBackgroundTimer = setInterval(() => {
      const currentIndex = this.backgrounds.indexOf(this.state.background);
      const nextIndex = (currentIndex + 1) % this.backgrounds.length;
      this.setState({
        background: this.backgrounds[nextIndex]
      });
    }, 5 * 60 * 1000); // 5 minutes in milliseconds
  }

  componentWillUnmount() {
    // Clear the timer when component unmounts
    if (this.switchBackgroundTimer) {
      clearInterval(this.switchBackgroundTimer);
    }
  }

  calculateTimeLeft = (bufferMinutes = 0) => {
    // Check if start_time is null or undefined
    if (this.props.ahWorkShift.start_time == null) {
      return { hoursLeft: 0, minutesLeft: 0 };
    }

    const currentTime = new Date();
    const targetTime = toDate(this.props.ahWorkShift.start_time);

    // Apply buffer (negative for time before start, positive for time after)
    const timeDifference = targetTime - currentTime - ((bufferMinutes) * 60 * 1000);

    const hoursLeft = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutesLeft = Math.ceil((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

    return { hoursLeft, minutesLeft };
  };

  timeLeft = () => {
    // Time left until 30 minutes before start (with 1-minute buffer)
    return this.calculateTimeLeft(30); // 29 minutes buffer
  };

  timeLeftToActualStart = () => {
    // Time left until actual start time
    return this.calculateTimeLeft(0); // No buffer
  };

  toLocalTime = isoDateTimeString => {
    if (this.props.ahWorkShift.start_time == null) {
      return "?";
    }
    const amsterdamTimeZone = 'Europe/Amsterdam';
    const zonedTime = utcToZonedTime(isoDateTimeString, amsterdamTimeZone);
    const formattedTime = formatTz(zonedTime, 'HH:mm', { timeZone: amsterdamTimeZone, locale: localeNL });
    return formattedTime;
  };

  toLocalDayAndNumber = isoDateTimeString => {
    if (this.props.ahWorkShift.start_time == null) {
      return "?";
    }
    const amsterdamTimeZone = 'Europe/Amsterdam';
    const zonedTime = utcToZonedTime(isoDateTimeString, amsterdamTimeZone);
    const formattedDayAndNumber = formatTz(zonedTime, 'eee d', { timeZone: amsterdamTimeZone, locale: localeNL }).replace(/^(\w{2})\w/, '$1');
    return formattedDayAndNumber;
  };

  render() {
    const timeStringNL = this.props.now && this.props.now.toLocaleTimeString('nl-NL', {
      hour12: false,
      hour: 'numeric',
      minute: 'numeric'
    });
    const temperature = (this.props.temperature != null) ? Math.round(this.props.temperature) : null;
    const lightSpot = this.props.lightSpot;
    const lightSpotState = lightSpot && typeof lightSpot.state === 'string' ? lightSpot.state : 'unknown';
    const lightSpotStateNl = lightSpotState === 'on' ? 'aan' : (lightSpotState === 'off' ? 'uit' : 'onbekend');
    const { hoursLeft, minutesLeft } = this.timeLeft();
    const { hoursLeft: hoursLeftToActual, minutesLeft: minutesLeftToActual } = this.timeLeftToActualStart();

    // Ensure we have valid numbers
    const safeHoursLeft = typeof hoursLeft === 'number' ? hoursLeft : 0;
    const safeMinutesLeft = typeof minutesLeft === 'number' ? minutesLeft : 0;
    const safeHoursLeftToActual = typeof hoursLeftToActual === 'number' ? hoursLeftToActual : 0;
    const safeMinutesLeftToActual = typeof minutesLeftToActual === 'number' ? minutesLeftToActual : 0;

    // Determine which countdown to show
    const totalMinutesToBuffer = safeHoursLeft * 60 + safeMinutesLeft;
    const totalMinutesToActual = safeHoursLeftToActual * 60 + safeMinutesLeftToActual;

    // Show "Vertrek" for 5 minutes after buffer expires (from 30 min before to 25 min before start)
    // Show red countdown from 25 minutes before start time onwards
    const showVertrek = totalMinutesToBuffer <= 0 && totalMinutesToActual > 25;
    const showRedCountdown = totalMinutesToBuffer <= 0 && totalMinutesToActual <= 25;

    const displayHours = showRedCountdown ? safeHoursLeftToActual : safeHoursLeft;
    const displayMinutes = showRedCountdown ? safeMinutesLeftToActual : safeMinutesLeft;

    const ahLogoColor = safeHoursLeft > 4 ? '#41619D' : '#3A4195';

    // Check if we should ignore night mode (countdown <= 60 minutes)
    const shouldIgnoreNightMode = totalMinutesToBuffer <= 60;
    const effectiveNightMode = shouldIgnoreNightMode ? false : this.props.isNightMode;
    const shouldHideBackground = effectiveNightMode;

    return (
      <FlexOuterWrapper
        hoursLeft={safeHoursLeft}
      >
        <BackgroundOverlay
          hoursLeft={safeHoursLeft}
          background={this.state.background}
          hideBackground={shouldHideBackground}
        />
        <TopText isNightMode={effectiveNightMode}>
          {this.props.ahWorkShift.task === 'exam' ? (
            <>Tentamen <StartTime>09:00 @ Flux Hall C</StartTime></>
          ) : (
            <><AhLogo color={ahLogoColor} /> {this.toLocalDayAndNumber(this.props.ahWorkShift.start_time)} van <StartTime>{this.toLocalTime(this.props.ahWorkShift.start_time)}</StartTime> tot {this.toLocalTime(this.props.ahWorkShift.end_time)}</>
          )}
        </TopText>
        <Countdown
          hoursLeft={displayHours}
          minutesLeft={displayMinutes}
          isRed={showRedCountdown}
          showVertrek={showVertrek}
          isNightMode={effectiveNightMode}
        />

        <BottomClock shouldScale={showVertrek} hoursLeft={safeHoursLeft} isNightMode={effectiveNightMode}>
          <Flag src={nl_flag} />
          {timeStringNL}
          {temperature !== null && (
            // <SecundaryColor> | {temperature}° | {lightSpotStateNl}</SecundaryColor>
            <SecundaryColor> | {temperature}°</SecundaryColor>
          )}
        </BottomClock>
        {/* <ForegroundOverlay
          hoursLeft={safeHoursLeft}
          hideBackground={shouldHideBackground}
        /> */}
      </FlexOuterWrapper>
    );
  }
}

const mapStateToProps = state => ({
  now: state.time.now,
  temperature: state.weather.temperature,
  feelsLike: state.weather.feelsLike,
  emoji: state.weather.emoji,
  ahWorkShift: state.ahwork,
  lightSpot: state.hassio.entities['light.spot_boxes'],
  isNightMode: selectIsNightMode(state)
});

export default connect(mapStateToProps)(WorkShift);
